
document.addEventListener("DOMContentLoaded", function () {

    const buttons = document.querySelectorAll('.read-more-btn');
        buttons.forEach(btn => {
            btn.addEventListener('click', () => {
            const desc = btn.previousElementSibling;
            const more = desc.querySelector('.more-content');
            const ellipsis = desc.querySelector('.ellipsis');
            
            if(more.style.display === 'none'){
                more.style.display = 'inline';
                ellipsis.style.display = 'none';
                btn.textContent = 'Read Less';
            } else {
                more.style.display = 'none';
                ellipsis.style.display = 'inline';
                btn.textContent = 'Read More';
            }
        });
    });

    const root = document.documentElement;

    function setQuantityWidth(el) {
        if (!el) return;
        const width = el.offsetWidth;
        const safeWidth = width > 0 ? width : 95;
        document.documentElement.style.setProperty("--quantity-width", safeWidth + "px");
    }

    const mo = new MutationObserver(() => {
        const el = document.querySelector('[data-block-type="quantity-selector"]');
        if (el) {
            setQuantityWidth(el);
            const ro = new ResizeObserver(() => setQuantityWidth(el));
            document.addEventListener("variant:change", () => setQuantityWidth(el));
            ro.observe(el);

            mo.disconnect();
        }
    });

    mo.observe(document.body, { childList: true, subtree: true });
});
